import React from 'react';

import { TYPE_F, TYPE_G } from '../../../common/constants/img';

import { useSmallScreen } from '../../../common/helpers/customHooks';

import Image from '../../../common/components/Image/Image';

import styles from './CarouselLogo.module.scss';

type Props = {
  url: string;
};

function CarouselLogo({ url }: Props) {
  const isSmallScreen = useSmallScreen();

  const dimensions = isSmallScreen ? TYPE_G : TYPE_F;

  return (
    <div
      className={styles.Wrapper}
      style={{
        width: dimensions.width,
        height: dimensions.height,
      }}
    >
      <Image src={url} width={dimensions.width} height={dimensions.height} />
    </div>
  );
}

export default CarouselLogo;
